import groq from 'groq'
import { imageAsset } from '../../imageAsset'

export const whyAum = groq`
 _type,
  title,
  subtitle,
  description,
    entities[] {
      label,
      logos[] {...${imageAsset()}},
    },
  bottomNote
`
